export const APP_VERSION = '0.1.15';
export const IS_DEV_MODE = false;
export const API_URL = IS_DEV_MODE ? 'http://localhost:3002' : 'https://materialised-ai-node.onrender.com';
export const WP_API_URL = IS_DEV_MODE ? 'http://materialised:8888' : 'https://materialised.com.au';
export const USE_CACHE = true;

export const numToPercent = (num) => {
    return Number(num).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 0 });
}